import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { InspectionOverlay } from '../../../model';

/** Natural pixel size of the loaded image, i.e. the coordinate system the overlay is expressed in. */
export interface ImagePixelSize {
  width: number;
  height: number;
}

/**
 * Draws the bucket circle, the stain circle and the stain boxes over an image.
 *
 * Place it inside a `position: relative` container that is exactly as large as the image. The SVG viewBox is the
 * image's natural pixel size, so the overlay coordinates (original image pixels) line up with the displayed image
 * at any size. Renders nothing until the image size is known and the overlay has something to draw.
 */
@Component({
  selector: 'app-inspection-overlay',
  templateUrl: './inspection-overlay.component.html',
  styleUrls: ['./inspection-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InspectionOverlayComponent {
  readonly overlay = input<InspectionOverlay | null | undefined>(null);
  readonly imageSize = input<ImagePixelSize | null | undefined>(null);

  protected readonly hasContent = computed(() => {
    const overlay = this.overlay();
    return !!overlay && (!!overlay.bucketCircle || !!overlay.stainCircle || !!overlay.stainBoxes?.length);
  });

  protected readonly viewBox = computed(() => {
    const size = this.imageSize();
    return size && size.width > 0 && size.height > 0 ? `0 0 ${size.width} ${size.height}` : null;
  });
}
